/**
 * Vuex 全局 getters
 * 提供对模块状态的快捷访问
 */
export default {
  /** 获取主题配置 */
  theme: (state) => state.theme,
  /** 获取用户状态 */
  user: (state) => state.user,
};
